<template>
  <div class="list-input-wrap">
    <p class="holder">{{placeholder}}，回车添加新行！</p>
    <ul class="list-input">
      <li v-for="(item, index) in list">
        <el-input :ref="'input' + index" :id="'input' + index" v-model="item.value" @keyup.enter.native="addRow(index)" @input="handleInput"/>
        <span @click="deleteByIndex(index)"><i class="el-icon-delete"></i></span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ListInput',
  props: {
    value: {
      type: String
    },
    // 分割符
    splitChar: {
      default: ','
    },
    placeholder: {
      default: '请输入'
    }
  },
  watch: {
    value (newValue) {
      this.list = newValue.split(this.splitChar).map(str => {
        return {
          value: str
        }
      })
    }
  },
  data () {
    return {
      list: [{ value: '' }]
    }
  },
  methods: {
    // 添加行
    addRow (index) {
      this.list.splice(index + 1, 0, { value: '' })
      this.$nextTick(() => {
        this.$refs['input' + (index + 1)][0].focus()
      })
    },
    // 处理输入
    handleInput () {
      this.$emit('input', this.list.filter(item => item.value.trim().length > 0).map(item => item.value).join(this.splitChar))
    },
    // 删除
    deleteByIndex (index) {
      if (this.list.length === 1) {
        this.list[0].value = ''
        return
      }
      this.list.splice(index, 1)
      this.handleInput()
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/style/variables";
.list-input-wrap {
  .holder {
    color: #999;
    margin: 0;
    font-size: 12px;
  }
  .list-input {
    li {
      margin-bottom: 10px;
      display: flex;
      & > .el-input {
        flex-grow: 1;
      }
      & > span {
        flex-shrink: 0;
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #999;
        &:hover {
          cursor: pointer;
          color: $primary-color;
        }
      }
    }
  }
}
</style>
